import * as React from 'react'
import { Box } from '@mui/material'
import { motion, AnimatePresence } from 'framer-motion'
import { wrap } from 'popmotion'
import ImageListItemBar from '@mui/material/ImageListItemBar'

const WIDTH = 600

const styleButton = {
  top: 'calc(50% - 20px)',
  position: 'absolute',
  background: 'rgb(0 0 0/5%)',
  borderRadius: '30px',
  width: '40px',
  height: '40px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  userSelect: 'none',
  cursor: 'pointer',
  fontWeight: 'bold',
  fontSize: '18px',
  zIndex: 2,
}

const next = {
  ...styleButton,
  right: '20px',
  '&:hover': {
    background: 'rgb(0 0 0/7%)',
    transform: 'scale(1.1)',
  },
}

const prev = {
  ...styleButton,
  left: '20px',
  transform: 'scale(-1)',
  '&:hover': {
    background: 'rgb(0 0 0/7%)',
    transform: 'scale(-1.1)',
  },
}

const ImagenGallery = ({ images, wWidth }) => {
  const swipeConfidenceThreshold = 10000
  const [[page, direction], setPage] = React.useState([0, 0])
  const [opacit, setOpacit] = React.useState(false)
  const imageIndex = wrap(0, images.length, page)

  const swipePower = (offset, velocity) => {
    return Math.abs(offset) * velocity
  }

  const variants = {
    enter: direction => {
      return {
        x: direction > 0 ? 500 : -500,
        opacity: 0,
      }
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
      scale: wWidth > WIDTH ? 0.84 : 1,
    },
    exit: direction => {
      return {
        zIndex: 0,
        x: direction < 0 ? 500 : -500,
        opacity: 0,
      }
    },
  }

  const paginate = newDirection => {
    setPage([page + newDirection, newDirection])
  }

  const container = {
    width: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  }

  React.useEffect(() => {
    if (!opacit) return
    setTimeout(() => setOpacit(false), 300)
  }, [opacit])

  const nextButton = () => {
    paginate(1)
    setOpacit(true)
  }
  const prevButton = () => {
    paginate(-1)
    setOpacit(true)
  }

  return (
    <Box sx={container}>
      <AnimatePresence initial={false} custom={direction}>
        <motion.img
          key={page}
          src={images[imageIndex].src}
          alt={images[imageIndex].title}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          style={{ width: '100%', height: '100%' }}
          transition={{ opacity: { duration: 0.1 } }}
          drag="x"
          dragConstraints={{ left: 0, right: 0 }}
          dragElastic={1}
          onDragEnd={(e, { offset, velocity }) => {
            const swipe = swipePower(offset.x, velocity.x)
            if (swipe < -swipeConfidenceThreshold) nextButton()
            else if (swipe > swipeConfidenceThreshold) prevButton()
          }}
        />
        <ImageListItemBar
          title={images[imageIndex].title}
          subtitle={images[imageIndex].author}
          sx={{
            scale: wWidth > WIDTH ? '0.84' : '1',
            height: 70,
            bottom: wWidth > WIDTH ? '7%' : '0%',
            zIndex: 1,
            opacity: opacit ? 0 : 1,
          }}
        />
      </AnimatePresence>
      {wWidth >= 900 ? (
        <>
          <Box onClick={nextButton} sx={next} children={'‣'} />
          <Box onClick={prevButton} sx={prev} children={'‣'} />
        </>
      ) : null}
    </Box>
  )
}

export default ImagenGallery
